import styled from "styled-components";

export const StyledButtonWrapper = styled.div`
    display: flex;
    margin-top: 24px;
`;
